import React from "react";
import { useTranslation } from "react-i18next";
import { Route as RouteIcon } from "lucide-react";

import { Card } from "../../components/ui/Card";
import { EmptyState } from "../../components/ui/EmptyState";

// Placeholder estático: aquí iba el listado de rutas (en construcción).
// Sin controles inertes ni altura fija enorme; solo el estado vacío real.
export default function RoutesList() {
  const { t } = useTranslation();
  return (
    <Card padding="none" className="w-full">
      <EmptyState
        icon={<RouteIcon />}
        title={t("Sin rutas")}
        description={t("Todavía no hay rutas creadas.")}
      />
    </Card>
  );
}
